module.exports = __webpack_public_path__ + "static/apple-touch-icon.0fea95fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/apple-touch-icon.png
// module id = 119
// module chunks = 79611799117203 207321357075633